import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function ModalRecorridoComponent({ textButton = "Modal", tituloModal = "Titulo Modal", link }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                {textButton}
            </Button>

            <Modal show={show} onHide={handleClose} fullscreen={true} centered dialogClassName="modal-recorrido">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={link} loading="lazy"></iframe>
                </Modal.Body>
            </Modal>
        </>
    )
}